import { Handle } from 'react-flow-renderer';

const SpecialCustomNode = ({ data }) => {
    const customNodeStyles = {
        background: '#F2F2F2 ',
        borderColor: '#0041d0',
        color: '#222',
        padding: '10px',
        width: 'fit-content',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        borderWidth: '1px',
        cursor: 'pointer',
        marginLeft: '20px',
    };
    return (
        <>
            <div style={customNodeStyles}>
                <Handle type="source" position="bottom" style={{ background: '#EB8C00' }} />
                <span
                    className="appkiticon
                icon-digital-transformation-outline"
                    style={{ fontSize: '2rem' }}
                />
            </div>
            <div style={{ marginBottom: '0.1rem' }}>{data.label}</div>
        </>
    );
};

export default SpecialCustomNode;
